import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { CurrencyInputField, InterestInputField } from 'components/form';

import { DealSheetFormValues } from './types';

interface Props {
  rowIndex: number;
}

export const ChargeAmountCell = ({ rowIndex }: Props) => {
  const { control } = useFormContext<DealSheetFormValues>();

  const typeValue = useWatch({ control, name: `charges.${rowIndex}.amountType` });

  if (typeValue === 'percent') {
    return (
      <InterestInputField
        label="Amount"
        control={control}
        name={`charges.${rowIndex}.amount`}
        textFieldProps={{ variant: 'outlined' }}
      />
    );
  }

  return (
    <CurrencyInputField
      label="Amount"
      control={control}
      allowNegative
      name={`charges.${rowIndex}.amount`}
      textFieldProps={{ variant: 'outlined' }}
    />
  );
};
